// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Heart = createSvgIcon(
  { All: <React.Fragment><path stroke="currentColor" strokeLinejoin="round" strokeWidth="2" d="M2.7035 2.9642C4.9748.367 8.6574.3346 10.9287 2.9318L12 4.1568l1.0713-1.225c2.2713-2.5972 5.9539-2.5648 8.2252.0324 2.2713 2.5972 2.2713 7.2319 0 9.8291L12 23 2.7035 12.7933c-2.2713-2.5972-2.2713-7.2319 0-9.829z" clipRule="evenodd" /></React.Fragment>, },
  'default'
);
